import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';
export function Hero() {
  return <header className="relative bg-white text-slate-700 pt-10 pb-12 md:pt-16 md:pb-20 overflow-hidden border-b border-slate-100" data-id="element-146">
      {/* Subtle orange background texture/pattern */}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none" style={{
      backgroundImage: 'radial-gradient(#F97316 1px, transparent 1px)',
      backgroundSize: '32px 32px'
    }} data-id="element-147"></div>

      <div className="max-w-5xl mx-auto px-6 md:px-12 relative z-10" data-id="element-148">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-center md:text-left" data-id="element-149">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-display font-bold leading-[1.1] mb-10 text-slate-900" data-id="element-150">
            Learn How to Buy Your First House{' '}
            <span className="text-orange-500" data-id="element-151">50% Off</span> Using the
            Step-by-Step Home Auction Secret Blueprint Today
            <span className="block text-base md:text-lg lg:text-xl text-orange-600 font-semibold mt-5" data-id="element-152">
              Just bid for the right deal, with the right amount, and get your
              first home up to 50% off, or walk away! (it's that simple)
            </span>
          </h1>

          <p className="text-lg md:text-xl font-sans font-medium text-slate-600 mb-10 max-w-2xl" data-id="element-153">
            For everyone tired of overpriced homes who wants a{' '}
            <span className="text-orange-500 font-semibold" data-id="element-154">
              smarter way in
            </span>
            .
          </p>

          <div className="flex md:block justify-center" data-id="element-155">
            <p className="text-lg md:text-xl lg:text-2xl text-slate-600 font-sans leading-relaxed max-w-3xl mb-14 border-l-4 border-orange-500 pl-6 text-left" data-id="element-156">
              You already know that getting a good deal on the major housing
              listing sites or through real estate agents is just impossible —
              it doesn't work. But what if you knew how to bid &amp; filter for
              the secret home auctions in your target zone? This
              beginner-friendly blueprint will teach you exactly that!
            </p>
          </div>

          <div className="flex flex-col sm:flex-row items-center gap-6 justify-start" data-id="element-157">
            <Button onClick={e => {
            e.preventDefault();
            document.getElementById('offer')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} data-id="element-158">
              Get Your First House 50% Off
            </Button>
            <div className="text-sm text-slate-500 flex items-center gap-2 font-medium" data-id="element-159">
              <svg className="w-4 h-4 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-160">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" data-id="element-161"></path>
              </svg>
              Instant PDF Download
            </div>
          </div>
        </motion.div>
      </div>
    </header>;
}